export default "__VITE_ASSET__Ct8uU24K__"